/**
 * @generated SignedSource<<06f9f11ecab71e7ca31556bbebc90527>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IterationFieldConfigFragment$data = {
  readonly configuration: {
    readonly completedIterations: ReadonlyArray<{
      readonly duration: number;
      readonly id: string;
      readonly startDate: any;
      readonly title: string;
      readonly titleHTML: string;
    }>;
    readonly iterations: ReadonlyArray<{
      readonly duration: number;
      readonly id: string;
      readonly startDate: any;
      readonly title: string;
      readonly titleHTML: string;
    }>;
  };
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "IterationFieldConfigFragment";
};
export type IterationFieldConfigFragment$key = {
  readonly " $data"?: IterationFieldConfigFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"IterationFieldConfigFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "titleHTML",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "startDate",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "duration",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IterationFieldConfigFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProjectV2IterationFieldConfiguration",
      "kind": "LinkedField",
      "name": "configuration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectV2IterationFieldIteration",
          "kind": "LinkedField",
          "name": "iterations",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectV2IterationFieldIteration",
          "kind": "LinkedField",
          "name": "completedIterations",
          "plural": true,
          "selections": (v1/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProjectV2IterationField",
  "abstractKey": null
};
})();

(node as any).hash = "4dd28ef853be8d84e527c48271b9f346";

export default node;
